import { scroller } from './scroll';
export function dropdown(element: HTMLElement): void {
  // Function ready in case JS is needed
  const parent = element.parentNode as HTMLElement;
  const contact_details = document.querySelector('.get_in_touch');

  const is_fine = matchMedia('(pointer:fine)').matches
  
  if (is_fine) {
    element.addEventListener('mouseover', () => {
      contact_details?.classList.remove('open');
    })
  }
  element.addEventListener('click', (e) => {
    e.preventDefault();
    parent.classList.toggle('open');
    contact_details?.classList.remove('open');
  });

  scroller.on('scroll', (e) => {
    parent?.classList.remove('open');
  });
  
  
}